import { render, staticRenderFns } from "./SliderUniform.vue?vue&type=template&id=0d4edcfa&scoped=true"
import script from "./SliderUniform.vue?vue&type=script&lang=js"
export * from "./SliderUniform.vue?vue&type=script&lang=js"
import style0 from "./SliderUniform.vue?vue&type=style&index=0&id=0d4edcfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4edcfa",
  null
  
)

export default component.exports